require("./uploadedExtractRow.scss");

//@vendors
const React = require('react');
const PropTypes = require('prop-types');
const get = require('lodash/object/get');

//@helper
const { FormattedText, formatText } = require('core/i18n').i18n;

//@commons
const { OKIconButton } = require('commonsComponents/OKIconButton');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { ModalCustom } = require('commonsComponents/modalCustom');

class uploadedExtractRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isImgPreviewerOpen: false,
            fileData:'',
            fileName: '',
        };
        this.handleImgPreviewerClick = this.handleImgPreviewerClick.bind(this);
    }

    handleImgPreviewerClick(fileData, fileName) {
        this.setState({
            isImgPreviewerOpen: !this.state.isImgPreviewerOpen,
            fileData,
            fileName
        });
    }

    buildContentRow(){
        const { removeFile, fileData } = this.props;

        const file = fileData.getIn(['data', 'file']);
        const fileType = get(file,'type','').split('/')[1];
        let previewContent;
        if(fileType !== 'pdf') {
            previewContent = (
                <div className="uploaded-documen-row__container-preview-img">
                    <OKButton
                        modifier="link-ghost"
                        onClick={(event) => {
                                this.handleImgPreviewerClick(fileData.getIn(['data', 'file', 'base64']), fileData.get('name'), event);
                        }}
                        >
                        <img
                            alt={formatText('externalTransferPlanStep1-uploadLabel')}
                            className="uploaded-documen-row__preview-img"
                            src={fileData.getIn(['data', 'file', 'base64'])}
                        />
                    </OKButton>
                </div>
            );
        }else {
            previewContent = (
                <div className="uploaded-documen-row__preview  uploaded-documen-row__preview--pdf-container icon-pdf"></div>
            );
        }
        
        return(
            <section className="uploaded-documen-row">
                <div className="uploaded-documen-row__preview pull-left">
                    {previewContent}
                </div>
                <div className="uploaded-documen-row__name pull-left">
                    <p className="uploaded-documen-row__label">
                        <FormattedText value="externalTransferPlanStep1-uploadLabel"/>
                    </p>
                    <p className="uploaded-documen-row__file-name">{fileData.get('name')}</p>
                </div>
                <div className="uploaded-documen-row__delete-button uploaded-documen-row__pull-right">
                    <OKIconButton icon="icon-eliminar" onClick={() => {
                        removeFile();
                    }}/>
                </div>
            </section>
        );
    }

    render() {
        return(
            <div>
                <ModalCustom
                    extraClass="uploaded-documen-row__custom-modal"
                    isOpen={this.state.isImgPreviewerOpen}
                    onRequestClose={this.handleImgPreviewerClick}
                    type="filter"
                >
                    <h3 className="uploaded-documen-row__modal-title">{this.state.fileName}</h3>
                    <div className="uploaded-documen-row__modal-preview">
                        <img
                            alt={formatText('externalTransferPlanStep1-uploadLabel')}
                            className="uploaded-documen-row__modal-preview-img"
                            src={this.state.fileData}
                        />
                    </div>
                </ModalCustom>
                {this.buildContentRow()}
            </div>
        );
    }
}

uploadedExtractRow.propTypes = {
    fileData: PropTypes.object,
    removeFile: PropTypes.func.isRequired,
    setDescription: PropTypes.func.isRequired
}
module.exports = uploadedExtractRow;
